<template>
	<!-- 头部 -->
	<div class="head">
		<!-- 登录注册 -->
		<div class="reg">
			<div class="box">
				<div class="lt">
					<router-link to="/"><img src="../../static/images/logo.png" ></router-link>
					<div class="kfpt">
						<h2>开放平台</h2>
						<span>ant-open-com</span>
					</div>
				</div>
				<div class="rt">
<!--					<router-link to="/reg">登录</router-link>-->
					<button @click="mfrz">免费入驻</button>
				</div>
			</div>
		</div>
		<maintai :isMfrz='isMfrz' @close='close'></maintai>
	</div>
</template>
<script>
	import maintai from './maintain.vue'
	export default {
		components:{
			maintai
		},
		data () {
			return {
			  isMfrz:false,						//免费入驻弹框
			}
		},
		methods:{
			//打开免费入驻弹框
			mfrz(){
				this.isMfrz = true
			},
			//关闭免费入驻弹框
			close(){
				this.isMfrz = false
			}
		}
	}
</script>

<style scoped>
/* 登录注册 */
.reg{width: 100%;height: .5rem;background-color: #061339;}
.reg .box{display: flex;justify-content: space-between;}
.reg .lt{display: flex;}
.reg .lt img{width: 1.32rem;margin-top: .06rem;height: .39rem;}
.reg .lt .kfpt{margin-left: .1rem;border-left: .01rem solid #FFFFFF;height: .29rem;margin-top: .105rem;padding-left: .11rem;}
.reg .lt .kfpt h2{font-size: .14rem;color: #FFFFFF;}
.reg .lt .kfpt span{font-size: .08rem;color: #FFFFFF;}
.reg .rt{margin-top: .07rem;}
.reg .rt a{color: #FFFFFF;margin-right: .31rem;line-height: .34rem;}
.reg .rt a:hover{color: #108ee9;}
.reg .rt button{border: .01rem solid #FFFFFF;border-radius: .06rem;padding: .1rem .19rem;color: #FFFFFF;line-height: .14rem;}
.reg .rt button:hover{color: #108ee9;border-color: #108ee9;}

</style>



// WEBPACK FOOTER //
// src/components/header.vue